// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import React from 'react'

import { trackEvent } from '../../../../lib/analytics'
import { useProductHrefWithQuery } from '../../../../lib/routing'

import * as Styles from './styles'

type Color = {
  name: string
  handle: string
  imageUrl: string | null
}

// Extracted to prevent nesting hooks
const ColorGalleryTile = ({ color }: { color: Color }) => {
  const productUrl = useProductHrefWithQuery({
    color: color.name,
    handle: color.handle,
  })

  return (
    <Link
      href={productUrl}
      {...trackEvent({
        action: 'click color tile',
        category: 'product details',
        value: `${color}`,
      })}
    >
      <Styles.Tile
        src={color.imageUrl || ''}
        alt={`${color.name} image`}
        loading='lazy'
        widths={{
          unit: 'px',
          sm: 150,
          md: 150,
        }}
        aspectRatios={{
          sm: 1,
          md: 1,
        }}
      />
      <Styles.TileName>{color.name}</Styles.TileName>
    </Link>
  )
}

export default ColorGalleryTile
